import { render } from "./TripWisePrintCountReportDetails.vue?vue&type=template&id=1fbc7936"
import script from "./TripWisePrintCountReportDetails.vue?vue&type=script&lang=js"
export * from "./TripWisePrintCountReportDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__